module.exports = "/packs/images/sprites/map~2d04c9c6c04eb8de3496ed4845540081.svg";